export const IMAGE_URL =
  process.env.REACT_APP_API_GAME_SERVICE_URL ||
  "https://gameservice.develop.erth.xyz";
